import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";
import { ACTIVATE_PROJECT, ASSIGN_USER_TO_PROJECT, COMPONENT_RENDERING_URL, CREATE_COMPANY, DEACTIVATE_PROJECT, EDIT_PROJECT, GET_COMPANIES, GET_COMPANY_TYPES, GET_DEACTIVATED_PROJECT, get_headers, GET_USERS_ASSIGNED_TO_PROJECT, USER_LIST_URLS, verify_super_user_status } from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import { validate_non_empty_string, validate_non_sub_zero_number } from '@/utils/validations/validate_inputs';
import axios from "axios";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';

export default {
  name: 'CompanyManagement',
  mixins: [alert_mixin, formatting_mixins],
  components: {
    navbar,
    GlobalTable,
    AICampusFooter
  },
  data: () => ({
    headers: get_headers(),
    company_types: [],
    company_list: [],
    table_headers: [],
    company_name: '',
    table_safe_company_list: [],
    selected_company_type: '',
    company_description: '',
    project_id: '',
    company_count: 0,
    is_loading: false,
    role: sessionStorage.getItem('user_role') || null,
    sidebar_components: [], // Store sidebar components
    sorted_sidebar_components: [], // Store sorted sidebar components
    users: [],
    users_list: [],
    user_table_headers: [],
    assigned_users: [],
    deactivated_projects: [],
    update_company_name: '',
    update_company_description: '',
    update_selected_company_type: [],
    hostname: '',
    hero_title: '',
    hero_description: '',
    is_super_user: false,
  }),

  computed: {
    first_component_url() {
      // Get the first URL from sorted sidebar components
      const first_url = this.find_first_component_with_url(this.sorted_sidebar_components);
      return first_url || '/overview'; // Fallback to /overview if no URL found
    }
  },
  mounted() {
    this.load_data();
    this.get_deactivated_projects();
    // safely define it once the component is mounted
    this.hostname = window.location.hostname || '';
    this.set_domain_content();
  },

  methods: {
    go_to_home() {
      this.$router.push('/company_management');
    },

    set_domain_content() {
      if (this.hostname.includes('trustfirst.probaanalytics')) {
        this.hero_title = 'Simplified Trust Administration and Registrations Solutions';
        this.hero_description = 'Trust us to Provide Solutions to your Trust Clients. Easy management of Trusts and Trusts assets with reliable, secure, and approved solutions by experienced Trust professionals.';
      }
      else {
        // default message
        this.hero_title = 'Simplified Workflow Automation and Compliance Solutions';
        this.hero_description = 'Seamlessly manage tasks , approvals and data verification through a secure , low-code platform.Designed by experts in risk , operations and compliance.';
      }
    },
    determine_sidebar(project_id) {
      const params = {
        role: this.role,
        project_id: project_id
      };
      return axios.get(COMPONENT_RENDERING_URL, {
        headers: this.headers,
        params
      })
        .then(response => {
          this.sidebar_components = response.data.data || [];
          this.sort_sidebar_components();
        })
        .catch(error => {
          this.show_error('Error getting sidebar configuration: ' + error);
          return [];
        });
    },

    sort_sidebar_components() {
      // Create a deep copy and sort the components
      const safe_components = (this.sidebar_components || []).map(component => {
        const safe_component = Object.assign({}, component || {});

        // Process sub-components
        safe_component.sub_components = (component.sub_components || [])
          .slice()
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
          .map(sub => {
            const safe_sub = Object.assign({}, sub || {});

            // Process child components
            safe_sub.child_components = (sub.child_components || [])
              .slice()
              .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

            return safe_sub;
          });

        return safe_component;
      });

      this.sorted_sidebar_components = safe_components.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    },

    find_first_component_with_url(components) {
      // Helper function to recursively find the first component with a URL
      const find_url = (component_list) => {
        for (const component of component_list) {
          // Check if the main component has a URL
          if (component.url && component.url.trim() !== '') {
            return component.url;
          }

          // Check sub-components
          if (component.sub_components && component.sub_components.length > 0) {
            const sub_url = find_url(component.sub_components);
            if (sub_url) return sub_url;
          }

          // Check child components
          if (component.child_components && component.child_components.length > 0) {
            const child_url = find_url(component.child_components);
            if (child_url) return child_url;
          }
        }
        return null;
      };

      return find_url(components || []);
    },

    async load_data() {
        this.is_loading = true;
          try {
            try {
              await Promise.all([
                this.is_super_user = await verify_super_user_status(),
                this.get_project_types(),
                this.get_companies(),
                this.fetch_users(),
              ]);
            } catch (error) {
              this.show_error('Error loading data: ' + error);
            }
          } finally {
            this.is_loading = false;
          }
    },

    role_class(role) {
      switch (role) {
        case "Admin":
          return "admin-badge";
        case "Owner":
          return "owner-badge";
        case "Member":
          return "member-badge";
        default:
          return "default-badge";
      }
    },

    get_project_types() {
      return this.show_loader("Loading company types...")
        .then(loader => {
          return axios.get(GET_COMPANY_TYPES, {
            headers: this.headers
          })
            .then(response => {
              const parsed_response = JSON.parse(response.data);
              if (parsed_response.data && parsed_response.data.length > 0) {
                this.company_types = parsed_response.data;
              } else {
                this.show_error('No company types found');
              }
              return this.close_loader(loader);
            })
            .catch(error => {
              this.show_error('Error getting company types: ' + error);
              return this.close_loader(loader);
            });
        });
    },

    get_companies() {
      this.company_list = [];
      return this.show_loader("Loading companies...")
        .then(loader => {
          return axios.get(GET_COMPANIES, {
            headers: this.headers
          })
            .then(response => {
              const parsed_response = JSON.parse(response.data);
              if (parsed_response.data && parsed_response.data.length > 0) {
                this.company_list = parsed_response.data;
                this.company_count = this.company_list.length;
                this.prep_tables();
              }
              return this.close_loader(loader);
            })
            .catch(error => {
              this.show_error('Error getting companies: ' + error);
              return this.close_loader(loader);
            });
        });
    },

    prep_tables() {
      this.table_safe_company_list = [];

      if (this.company_list.length > 0) {
        this.table_safe_company_list = this.company_list.map(company => ({
          "id": company.id,
          "Client": company.name,
          "Description": company.project_description,
          "Type": company.project_type.name,
          "Date Created": this.format_date(company.date_created),
          "Assigned Administrator": company.creator.full_name,
        }));
        this.table_headers = Object.keys(this.table_safe_company_list[0]);
      } else {
        this.table_headers = ["Client", "Description", "Type", "Date Created", "Assigned Administrator"];
      }
    },

    create_company() {
      const company_name = this.company_name;
      const company_description = this.company_description;
      const company_type = this.selected_company_type;

      if (!validate_non_empty_string(company_name)) {
        this.show_error('Company name must not be empty');
        return Promise.resolve();
      }

      if (!validate_non_empty_string(company_description)) {
        this.show_error('Company description must not be empty');
        return Promise.resolve();
      }

      if (!validate_non_sub_zero_number(company_type)) {
        this.show_error('Please select a valid company type');
        return Promise.resolve();
      }

      const payload = {
        project_name: company_name,
        project_description: company_description,
        project_type_id: company_type,
      };

      return this.show_loader("Creating company...")
        .then(loader => {
          return axios.post(CREATE_COMPANY, payload, {
            headers: this.headers
          })
            .then(() => {
              this.close_modal('create_company');
              window.location.reload();
              return this.get_companies()
                .then(() => this.close_loader(loader));
            })
            .catch(error => {
              this.show_error('Error creating company: ' + error);
              return this.close_loader(loader);
            });
        });
    },

    redirect_to_overview(project_id, company_name) {
      this.project_id = project_id;
      this.company_name = company_name;
      sessionStorage.setItem('project_id', project_id);
      sessionStorage.setItem('company_name', company_name);

      // Fetch sidebar for this specific project, then navigate
      this.determine_sidebar(project_id)
        .then(() => {
          this.$router.push({
            path: this.first_component_url,
          });
        })
        .catch(() => {
          this.$router.push({
            path: '/overview', // Fallback
          });
        });
    },

    redirect_to_config(project_id=null, company_name=null) {
      this.project_id = project_id;
      this.company_name = company_name;
      sessionStorage.setItem('project_id', project_id);
      sessionStorage.setItem('company_name', company_name);
      this.$router.push({
        path: '/user_management',
      });
    },

    async select_project(project_id) {
      this.assigned_users = [];
      this.project_id = project_id;

      const payload = { project_id: this.project_id };
      const response = await axios.post(GET_USERS_ASSIGNED_TO_PROJECT, payload, { headers: this.headers });

      if (response.data.data && Array.isArray(response.data.data)) {
        // Only store the IDs of assigned users
        this.assigned_users = response.data.data.map(item => item.assignee);
      } else {
        this.assigned_users = [];
      }
    },


    async fetch_users() {
      axios.get(USER_LIST_URLS, { headers: this.headers })
        .then(response => {
          const res = JSON.parse(response.data);

          this.users = res.data.map(user => ({
            user_id: user.user_id,
            name: (user.user.first_name && user.user.last_name)
              ? user.user.first_name + " " + user.user.last_name
              : "User has not logged in",
            email: user.user.email,
          }));

          this.users_list = this.users;
          this.user_table_headers = Object.keys(this.users_list[0]);
        })
        .catch(() => {
          this.show_error("Error fetching users");
        });
    },

    toggle_assignment(user_id) {
      const payload = {
        project_id: this.project_id,
        user_id: user_id
      };

      if (this.assigned_users.includes(user_id)) {
        payload.is_assigned = false;
      } else {
        payload.is_assigned = true;
      }

      axios.post(ASSIGN_USER_TO_PROJECT, payload, { headers: this.headers })
        .then(() => {
          if (payload.is_assigned) {
            this.assigned_users.push(user_id);
          } else {
            this.assigned_users = this.assigned_users.filter(id => id !== user_id);
          }
        })
        .catch(() => {
          this.show_error("Error fetching users");
        });
    },

    initialize_data_table() {
          this.$nextTick(() => {
            $('#deactivated_projects_table').DataTable({
              responsive: true,
              emptyTable: "No data available in table",
              order: [[0, 'desc']],
              language: {
                info: "",
                lengthMenu: "_MENU_&nbsp;&nbsp;Entries per page"
              }
            });
          });
        },

    deactivate_company(project_id){
      this.show_confirm(
        "Deactivate Client",
        "Are you sure you want to deactivate this client?",
        ()=>{
          const payload = {
            project_id: project_id
          }

          axios.post(DEACTIVATE_PROJECT, payload, {
            headers: this.headers
          }).then(response => {
            const response_data = JSON.parse(response.data);
            if (response_data.status === "success") {
              this.show_success("Client successfully deactivated");
              window.location.reload();

            } else {
              this.show_error(response_data.message || "Failed to deactivate client");
            }
          })
          .catch(error => {
            this.show_error("Error deactivating client: " + error);
        })})
      },

    get_deactivated_projects() {
      axios.get(GET_DEACTIVATED_PROJECT, { headers: this.headers })
        .then(response => {
          const parsed_response = JSON.parse(response.data);
          if (parsed_response.status === "success") {
            this.deactivated_projects = parsed_response.data;
            this.$nextTick(() => this.initialize_data_table());
          } else {
            this.show_error(parsed_response.message || "No deactivated client found");
          }
        })
        .catch(error => {
          this.show_error("Error fetching deactivated clients: " + error);
      });
    },

    activate_projects(project_id){
       const payload = {
            project_id: project_id
          }

        axios.post(ACTIVATE_PROJECT, payload, {
          headers: this.headers
          }).then(response => {
            const response_data = JSON.parse(response.data);
            if (response_data.status === "success") {
              this.show_success("Client activated successfully");
              window.location.reload();

            } else {
              this.show_error(response_data.message || "Failed to activate client");
            }
          })
          .catch(error => {
            this.show_error("Error activating client: " + error);
        })
    },

    prepopulate_update_company_modal(project_id){
      const project = this.company_list.find(c => c.id === project_id);
      if (!project) return;

      this.project_id = project.id;
      this.update_company_name = project.name || '';
      this.update_company_description = project.project_description || '';
      this.update_selected_company_type = project.project_type?.id || '';
    },

    update_project(){
      if (!validate_non_empty_string(this.update_company_name)) {
        this.show_error('Client name must not be empty');
        return;
      }
      if (!validate_non_empty_string(this.update_company_description)) {
        this.show_error('Client description must not be empty');
        return;
      }
      if (!validate_non_sub_zero_number(this.update_selected_company_type)) {
        this.show_error('Please select a valid client type');
        return;
      }

      const payload ={
        project_id: this.project_id,
        project_name: this.update_company_name,
        project_description: this.update_company_description,
        project_type_id: this.update_selected_company_type,
      }

      axios.post(EDIT_PROJECT, payload,{
        headers: this.headers
      }).then(response => {
        const response_data = JSON.parse(response.data);
        if (response_data.status === "success") {
          this.show_success("Client updated successfully");
          this.close_modal("update_company")
          window.location.reload();
        } else {
          this.show_error(response_data.message || "Failed to update client");
        }
      })
      .catch(error => {
        this.show_error("Error updating client: " + error);
      })
    }
  },
}
